import React from 'react';

const bookings = [
  {
    id: 1,
    title: 'Mentorship Session with Riya',
    time: 'Tomorrow, 5:00 PM',
    type: 'Video Call',
  },
  {
    id: 2,
    title: 'Client Review: Signal Package',
    time: 'May 26, 11:00 AM',
    type: 'Zoom Meeting',
  },
  {
    id: 3,
    title: 'Investor Pitch: AutoFXBot',
    time: 'May 28, 2:30 PM',
    type: 'Google Meet',
  },
];

export default function UpcomingBookingsBox() {
  return (
    <div className="bg-white shadow rounded-lg p-4 mb-6">
      <h3 className="text-sm font-semibold mb-3 text-gray-800">📅 Upcoming Bookings</h3>
      <ul className="space-y-3 text-sm text-gray-700">
        {bookings.map((item) => (
          <li
            key={item.id}
            className="p-3 bg-gray-50 rounded border-l-4 border-blue-500 shadow-sm"
          >
            <div className="font-semibold text-blue-800">{item.title}</div>
            <div className="text-xs text-gray-500">{item.time} — {item.type}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
